define('lib/view_helpers/time',['require','underscore','jquery','lib/jquery/jquery.timeentry','lib/view_helpers/base','lib/Podio.Utils','lib/Podio.Config','lib/Podio.Time','moment'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.timeentry');

  var viewHelpers = require('lib/view_helpers/base');
  var utils = require('lib/Podio.Utils');
  var podioConfig = require('lib/Podio.Config');
  var podioTime = require('lib/Podio.Time');
  var moment = require('moment');

  var defaultOptions = {};

  function buildTimestamp(date, title, text, options) {

    options = $.extend({
      autoupdate: true,
      includeTooltip: true,
      url: null
    }, options);

    var tagName = options.autoupdate === true ? 'time' : 'span';

    var attributes = {
      'class'                 : 'timestamp',
      'text'                  : text,
      'datetime'              : date
    };
    if (options.includeTooltip) {
      attributes = {
        "title"                 : title,
        'class'                 : 'timestamp tooltip tooltip-datetime',
        'data-tooltip-gravity'  : 's',
        'text'                  : text,
        'datetime'              : date
      };
    }

    var returnString = viewHelpers.content_tag(tagName, attributes);
    if (options.url) {
      returnString = viewHelpers.content_tag('a', {html:returnString, href: options.url});
    }
    return returnString;

  }

  function timestamp(date, options) {
    var localDate = moment.min(podioTime.localMomentFromString(date), podioTime.current());
    return buildTimestamp(date, localDate.format('LLL'), localDate.from(podioTime.current()), options);
  }

  function absoluteTimestamp(date, options) {
    options = _.extend(options || {}, {autoupdate: false});
    var localDate = podioTime.localMomentFromString(date);
    return buildTimestamp(date, localDate.format('LLL'), localDate.format('L'), options );
  }

  function absoluteDateTime(date, options) {
    var localDate = podioTime.localMomentFromString(date);
    return localDate.format('LLL');
  }

  function cascadingTimestamp(date, formatOptions) {
    var defaultFormatOptions = {
      same_week: 'dddd',
      same_year: podioConfig.localeSettings.customDateTimeFormats.longDateWithoutYear,
      same_day: null,
      later: 'L',
      tooltip: 'LLL'
    };

    formatOptions = _.extend(defaultFormatOptions, formatOptions || {});

    var localDate = podioTime.localMomentFromString(date);
    var currentTimestamp = podioTime.current();
    var result;

    if (localDate.isSame(currentTimestamp, 'day')) {
      return formatOptions.same_day ? localDate.format(formatOptions.same_day) : podioTime.formatTime(localDate);
    } else if (localDate.isSame(currentTimestamp, 'week')) {
      result = localDate.format(formatOptions.same_week);
    } else if (localDate.isSame(currentTimestamp, 'year')) {
      result = localDate.format(formatOptions.same_year);
    } else {
      result = localDate.format(formatOptions.later);
    }

    return buildTimestamp(date, localDate.format(formatOptions.tooltip), result, {autoupdate: false});
  }

  function timeWithTooltip(date, options) {
    var localDate = podioTime.localMomentFromString(date);
    var currentTimestamp = podioTime.current();
    var time = podioTime.formatTime(localDate);

    if(localDate.diff(currentTimestamp, 'days') === 0) {
      return time;
    } else {
      return buildTimestamp(date, localDate.format('L'), time, {autoupdate: false});
    }
  }

  function formatTime(date, options) {
    var localDate = podioTime.localMomentFromString(date);
    return podioTime.formatTime(localDate);
  }

  function localMomentFromString(dateString) {
    return podioTime.localMomentFromString(dateString);
  }

  function localMomentFromDate(date) {
    return podioTime.localMomentFromDate(date);
  }

  var exports = {
    timestamp: timestamp,
    absoluteTimestamp: absoluteTimestamp,
    absoluteDateTime: absoluteDateTime,
    cascadingTimestamp: cascadingTimestamp,
    timeWithTooltip: timeWithTooltip,
    formatTime: formatTime,
    localMomentFromString: localMomentFromString,
    localMomentFromDate: localMomentFromDate
  };

  viewHelpers.registerHelpers(exports);

  return exports;

});

